import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchEvents,
  fetchtApplicationDetails,
  handleAddEvent,
  locationMasters,
} from "../../redux/actions/grievanceActions1";

const AddEvent = ({ onClose, show }) => {
  // Separate state for each field
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventFromTime, setEventFromTime] = useState("");
  const [eventToTime, setEventToTime] = useState("");
  const [location, setLocation] = useState("");
  const [eventDesc, setEventDesc] = useState("");
  const [importantGuests, setImportantGuests] = useState("");
  const [eventUrl, setEventUrl] = useState("");

  // Error state
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { locationMaster } = useSelector((state) => state.grievances);

  useEffect(() => {
    dispatch(locationMasters());
  }, [dispatch]);
  // Validation function
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) newErrors.title = "Event title is required";
    if (!eventDate) newErrors.eventDate = "Event date is required";
    if (!eventFromTime) newErrors.eventFromTime = "Start time is required";
    if (!eventToTime) newErrors.eventToTime = "End time is required";
    if (!location.trim()) newErrors.location = "Location is required";
    if (!eventDesc.trim())
      newErrors.eventDesc = "Event description is required";

    // Validate time logic
    if (eventFromTime && eventToTime && eventFromTime >= eventToTime) {
      newErrors.eventToTime = "End time must be after start time";
    }

    // Validate date (not in the future)
    if (eventDate) {
      const selectedDate = new Date(eventDate);
      selectedDate.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate > today) {
        newErrors.eventDate = "Event date cannot be in the future";
      }
    }

    // Validate URL format if provided
    // if (eventUrl && eventUrl.trim()) {
    //   const urlPattern =
    //     /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    //   if (!urlPattern.test(eventUrl.trim())) {
    //     newErrors.eventUrl = "Please enter a valid URL";
    //   }
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateEvent = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const eventData = {
        addInfo: {
          title: title.trim(),
          event_date: eventDate,
          event_from_time: eventFromTime + ":00",
          event_to_time: eventToTime + ":00",
          location: location.trim(),
          event_desc: eventDesc.trim(),
          important_guests: importantGuests.trim() || "",
          event_url: eventUrl.trim() || "",
        },
      };

      const res = await dispatch(handleAddEvent(eventData));
      if (res.rCode == 0) {
        alert(res.rMessage || "Event created successfully!");
        resetForm();
        onClose();
        await dispatch(fetchEvents());
      } else {
        alert(res.rMessage || "Error in Add Event!");
      }
    } catch (error) {
      console.error("Error creating event:", error);
      alert("Error creating event. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setTitle("");
    setEventDate("");
    setEventFromTime("");
    setEventToTime("");
    setLocation("");
    setEventDesc("");
    setImportantGuests("");
    setEventUrl("");
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="CreateEventModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="addEvent-exampleModalLabel"
            >
              Add New Event
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Event Title */}
            <div className="mb-3">
              <label htmlFor="event-title" className="form-label">
                Event Title <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.title ? "is-invalid" : ""}`}
                id="event-title"
                placeholder="Enter event title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {errors.title && (
                <div className="invalid-feedback">{errors.title}</div>
              )}
            </div>

            {/* Event Date */}
            <div className="mb-3">
              <label htmlFor="event-date" className="form-label">
                Event Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={`form-control ${
                  errors.eventDate ? "is-invalid" : ""
                }`}
                id="event-date"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
                onClick={(e) => e.target.showPicker()}
                max={new Date().toISOString().split('T')[0]}
              />
              {errors.eventDate && (
                <div className="invalid-feedback">{errors.eventDate}</div>
              )}
            </div>

            {/* Time Fields */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="event-from-time" className="form-label">
                  Start Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className={`form-control ${
                    errors.eventFromTime ? "is-invalid" : ""
                  }`}
                  id="event-from-time"
                  value={eventFromTime}
                  onChange={(e) => setEventFromTime(e.target.value)}
                />
                {errors.eventFromTime && (
                  <div className="invalid-feedback">{errors.eventFromTime}</div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="event-to-time" className="form-label">
                  End Time <span className="text-danger">*</span>
                </label>
                <input
                  type="time"
                  className={`form-control ${
                    errors.eventToTime ? "is-invalid" : ""
                  }`}
                  id="event-to-time"
                  value={eventToTime}
                  onChange={(e) => setEventToTime(e.target.value)}
                />
                {errors.eventToTime && (
                  <div className="invalid-feedback">{errors.eventToTime}</div>
                )}
              </div>
            </div>

            {/* Location */}
            {/* <div className="mb-3">
              <label htmlFor="event-location" className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  errors.location ? "is-invalid" : ""
                }`}
                id="event-location"
                placeholder="Enter event location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
              {errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div> */}
            <div className="mb-3">
              <label htmlFor="event-location" className="form-label">
                Location <span className="text-danger">*</span>
              </label>
              <select
                className={`form-control ${
                  errors.location ? "is-invalid" : ""
                }`}
                id="event-location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Select Location</option>
                {locationMaster && locationMaster.length > 0 ? (
                  locationMaster
                    .filter((loc) => loc.location_name !== "Select Location") // Filter out default option if it exists
                    .map((loc) => (
                      <option key={loc.location_id} value={loc.location_id}>
                        {loc.location_name}
                      </option>
                    ))
                ) : (
                  <option value="" disabled>
                    Loading locations...
                  </option>
                )}
              </select>
              {errors.location && (
                <div className="invalid-feedback">{errors.location}</div>
              )}
            </div>

            {/* Event Description */}
            <div className="mb-3">
              <label htmlFor="event-desc" className="form-label">
                Event Description <span className="text-danger">*</span>
              </label>
              <textarea
                className={`form-control ${
                  errors.eventDesc ? "is-invalid" : ""
                }`}
                id="event-desc"
                rows="3"
                placeholder="Enter event description"
                value={eventDesc}
                onChange={(e) => setEventDesc(e.target.value)}
              ></textarea>
              {errors.eventDesc && (
                <div className="invalid-feedback">{errors.eventDesc}</div>
              )}
            </div>

            {/* Important Guests */}
            <div className="mb-3">
              <label htmlFor="important-guests" className="form-label">
                Important Guests
              </label>
              <textarea
                className="form-control"
                id="important-guests"
                rows="2"
                placeholder="Enter important guests (optional)"
                value={importantGuests}
                onChange={(e) => setImportantGuests(e.target.value)}
              ></textarea>
            </div>

            {/* Event URL */}
            <div className="mb-3">
              <label htmlFor="event-url" className="form-label">
                Event URL
              </label>
              <input
                type="url"
                className={`form-control ${
                  errors.eventUrl ? "is-invalid" : ""
                }`}
                id="event-url"
                placeholder="https://example.com/event"
                value={eventUrl}
                onChange={(e) => setEventUrl(e.target.value)}
              />
              {errors.eventUrl && (
                <div className="invalid-feedback">{errors.eventUrl}</div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleCreateEvent}
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Creating...
                </>
              ) : (
                "Add Event"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;
